import { useAuthenticator } from '@features/auth/utils/useAuthenticator'
import { useGetIndexStatus } from '@features/indexing/hooks/useGetIndexStatus'
import { useGetSystemStatus } from '@features/system-status/hooks/useGetSystemStatus'
import Circle from '@mui/icons-material/Circle'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import { isAxiosError } from 'axios'
import { useTranslation } from 'react-i18next'

export const SystemStatus = () => {
  const { data, isLoading, isError, error } = useGetSystemStatus()
  const { t } = useTranslation()
  const { user } = useAuthenticator()
  const { data: statusData, isLoading: isLoadingStatus } = useGetIndexStatus()

  const numberOfProcessedFiles = statusData?.number_of_processed_files || 0
  // const numberOfFailedFiles = statusData?.number_of_failed_files || 0
  const numberOfFilesSubmitted = statusData?.number_of_files_submitted || 0
  const is500 = isAxiosError(error) ? error.response?.status === 500 : false

  const getStatusIcon = () => {
    if (isLoading || isLoadingStatus) {
      return (
        <CircularProgress
          size={20}
          sx={{
            position: 'absolute',
            top: '50%',
            left: '75%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      )
    }

    if (isError || is500) {
      return (
        <Circle
          fontSize="small"
          color="error"
          sx={{
            position: 'absolute',
            top: '50%',
            left: '75%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      )
    }

    if (data?.status === 'ok') {
      return (
        <Circle
          fontSize="small"
          sx={{
            position: 'absolute',
            top: '50%',
            left: '75%',
            transform: 'translate(-50%, -50%)',
            color: (theme) => theme.palette.success.light,
          }}
        />
      )
    }
    return null
  }

  return (
    <Box
      display="flex"
      justifyContent="flex-end"
      alignContent="center"
      alignItems="center"
      sx={{ py: 1.25 }}
    >
      {!!user && (
        <>
          {/* <Box>
            <Typography component="span">{t('layout.header.index_status.text')}:</Typography>
          </Box>
          <Box
            ml={0.5}
            mr={1}
          >
            {isLoading ? (
              <Skeleton
                variant="text"
                width={150}
              />
            ) : (
              <>
                <Typography
                  component="span"
                  color={
                    getColorByStatus(statusData?.status) === 'primary'
                      ? 'primary.dark'
                      : getColorByStatus(statusData?.status)
                  }
                  sx={{ transition: '0.3s all' }}
                  align="right"
                >
                  {statusData?.status ? t(`index.status.${statusData.status}`) : 'No index'}
                </Typography>
                <Typography
                  component="span"
                  align="right"
                  sx={{ ml: 1 }}
                >
                  ({numberOfProcessedFiles} / {numberOfFilesSubmitted})
                </Typography>
              </>
            )}
          </Box> */}
          {/* <Box sx={{ mr: 1, height: 30 }}>
            <Divider
              orientation="vertical"
              sx={{ borderWidth: 1 }}
            />
          </Box> */}
        </>
      )}
      <Box>
        <Typography component="span">{t('layout.header.system_status.text')}:</Typography>
      </Box>
      <Box sx={{ ml: 0.5, mr: 1, position: 'relative', width: '20px', height: '20px' }}>{getStatusIcon()}</Box>
      <Box sx={{ mx: 1, height: 30 }}>
        <Divider
          orientation="vertical"
          sx={{ borderWidth: 1 }}
        />
      </Box>
    </Box>
  )
}
